import React from "react"
import styled from 'styled-components'
import { graphql } from 'gatsby'
import Layout from "../components/layout"
import Logo from "../components/logo"
import SEO from "../components/seo"
import ContactForm from '../components/ContactForm'
import DonationSection from '../components/DonationsSection'
import Img from 'gatsby-image'
import DefaultBanner from '../components/common/DefaultBanner'
import { useMediaQuery } from 'react-responsive'

const Content = styled.div`
    width: 95%;
    border-radius: 10px;
    background: white;
    position: relative;
    max-height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .banner-container {
      width: 100%;
    }
    
    > .content-info {
      padding: 25px 20px 20px 20px;
    }

    ::-webkit-scrollbar {
      display: none;
    };

    blockquote {
      position: relative;
      font-size: 1.3em;
      padding-left: 1em;
      border-left: 0.2em solid #ddd;
      font-weight: 100;
      font-style: italic;
      line-height: 2em;
      margin-top: 20px;
    }

    ul {
      list-style: disc;
    }
    
    h2 { 
      margin-top: 20px;
    }

    h3 {
      margin-top: 20px;
    }
  `

const GenericContent = ({data}) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' });
  const { markdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark
  let image = <DefaultBanner />
    
  if (frontmatter.image !== null) {
    image = <Img style={{width: '100%'}} fluid={frontmatter.image.childImageSharp.fluid} />
  }

  return (
    <Layout>
      <SEO 
      title={frontmatter.title} 
      image={frontmatter.image ? frontmatter.image.childImageSharp.fluid.src : null}
      description={markdownRemark.excerpt}
      />
      {isTabletOrMobile ?       
        <div style={{width: '100%', paddingBottom: '15px'}}>
          <Logo width='180px' margin='0' />
        </div> :
        <div style={{position: 'relative', top: '-30px', left: '0px', width: '300px'}}>
          <Logo width='240px' margin='0' />
        </div>
      }
      <div className="is-centered is-paddingless" style={{height: 'calc(100vh - 165px', marginTop: '-10px'}}>
        <Content style={isTabletOrMobile ? {width: `100%`} : {width: `80%`}}>
          <div className="content-info" style={isTabletOrMobile ? {width: `100%`} : {width: `80%`}}>
            <h1 style={{marginBottom: '0'}}>{frontmatter.title}</h1>
          </div>
          <div className="banner-container">
            {image}
          </div>
          {frontmatter.title === 'Donate' ? 
          <div className="content-info" style={isTabletOrMobile ? {width: `100%`} : {width: `80%`}}><DonationSection /></div> 
          : null}
          <div className="content-info" style={isTabletOrMobile ? {width: `100%`} : {width: `80%`}} dangerouslySetInnerHTML={{ __html: html }} />

          {frontmatter.title === 'Contact' ? <div style={{width: '100%'}}><ContactForm /></div> : null}
        </Content>
      </div>
    </Layout>
  )
}

export const storyQuery = graphql`
  query($path: String!, $imageFocus: ImageCropFocus) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      excerpt(pruneLength: 100)
      frontmatter {
        path
        title
        image {
          childImageSharp {
            fluid(maxWidth: 800, maxHeight: 250, quality: 90, cropFocus: $imageFocus) {
              ...GatsbyImageSharpFluid
              src
            }
          }
        }
      }
    }
  }
`

export default GenericContent
